
export const cpfMask = (inputCpf: string) => {
    const cpf = inputCpf.replace(/[^0-9]/g, "").replace("-","")
    let newValue = cpf.substr(0, 3) + (cpf.length > 3 ? "." + cpf.substr(3, 3) : "") + (cpf.length > 6 ? "." + cpf.substr(6, 3) : "") + (cpf.length > 9 ? "-" + cpf.substr(9, 2) : "")
    return newValue
}
